import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'


import {
    FETCH_ADMIN_SERVICES,
    DELETE_ADMIN_SERVICE, ADD_ADMIN_SERVICE,
    UPDATE_ADMIN_SERVICE, CLEAR_SELECTED_SERVICES
} from "actions/actionTypes";
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList, displayCustomDialog} from 'util/Utils';
import AdminServiceListTable from 'dashboard/services/AdminServiceListTable';
import AdminServiceSearchBox from 'dashboard/services/AdminServiceSearchBox'
import AdminServicesActionsBox from 'dashboard/services/AdminServicesActionsBox'
import Datetime from 'react-datetime'
import momentTimeZone from 'moment-timezone'
import {
    checkValidDates,
    fetchServiceSettings,
    fetchDateRules,
    updateSelectedServiceData,
    getScheduledServices,

}  from 'shared/sharedMethods';
import config from  '../../../config';
import {validateEmail}  from 'util/Utils';
import RemoveModalDialog from'shared/RemoveModalDialog';


class AdminServicesPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }


    constructor(props, context) {
        super(props, context);
       var stateData = {
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            showModal: false,
            PickupDate: false,
            TimeWindow: false,
            serviceAreasForLocation: [],
            ServiceType: '',
            ScheduledPickups: [],
            ScheduledDropoffs: [],
            Size: false,
            currentRecord: {},
            administratorMode: false,
            errors: {},
            sortBy: '',
            perPage: config.table.numberPerPage,
            DropoffDateRules: [],
            PickupDateRules: [],
           dataToDisplay:[],
            WingmomUsers: [],
            showAdministratorModeCheckBox: true
          //  userEmailsToCrossPost: [],
        };
        if (this.props.location.pathname.includes('/services/add')) {
            stateData.showModal = true
            stateData.currentRecord= {
                _id:'new_record'
            }
            this.fetchSellerRecord()
        }
        this.state = stateData
        this.moment = momentTimeZone;
        this.filteredServiceAreasForLocation = []
        this.orderData = {
            'Pickup': {
                maximumSizeNumberForTimeSlot: 8,
                maximumSizeNumberForDay : 18,
                bookNotEarlierThanDaysNumber: 3,
                'timeWindowOptions': [],
                sizeOptions: []
            },
            'Mail In': {
                'timeWindowOptions': [],
                bookNotEarlierThanDaysNumber: 0,
                maximumSizeNumberForDay : 12,
                sizeOptions: [],
                DaysOfWeek: [],
            },
            'Dropoff': {
                'timeWindowOptions': [],
                bookNotEarlierThanDaysNumber: 0,
                maximumSizeNumberForDay : 12,
                sizeOptions: [],
                DaysOfWeek: [],
            }
        }
    };

    componentWillMount() {
        this.fetchServiceAreas()
    }
    componentWillUnmount() {
        momentTimeZone.tz.setDefault();
        /* restore default timezone to user local timezone*/
    }
    fetchSellerRecord(){
        var self = this
        var methodData = {
             'endpoint': '/sellers/' + encodeURIComponent(this.props.location.query.SellerID),
            'not_display_success_message': true,
        };
         this.props.makeRequest({}, methodData).then(res => {
             self.setState({currentRecord:{
                _id:'new_record',
            SellerID:res.data}})
        }).catch(function(err) {
             self.setState({showModal:false, currentRecord:{ }})
        })
    }
    fetchServiceAreas() {
        var self = this;
        this.props.makeRequest({}, {
            "endpoint": "/service_areas"
        }).then(function (res) {
                var serviceAreasByMarket = _.groupBy(res.data.data, 'MarketName')
            console.log('serviceAreasByMarket', serviceAreasByMarket  );
                self.setState({serviceAreasByMarket: serviceAreasByMarket})
            })
    }

    getTimeOptions() {
        if (this.state.ServiceType == 'Pickup' && this.state.administratorMode) {
            return [
                {'label': '8am - 10am', disabled: false, 'value': '8_10'},
                {'label': '9am - 11am', disabled: false, 'value': '9_11'},
                {'label': '10am - 12pm', disabled: false, 'value': '10_12'},
                {'label': '11am - 1pm', disabled: false, 'value': '11_13'},
                {'label': '12pm - 2pm', disabled: false, 'value': '12_14'},
                {'label': '1pm - 3pm', disabled: false, 'value': '13_15'},
                {'label': '2pm - 4pm', disabled: false, 'value': '14_16'},
                {'label': '3pm - 5pm', disabled: false, 'value': '15_17'},
                {'label': '8am - 5pm', disabled: false, 'value': '8_17'}
            ]
        } else {
            return _.get(this.orderData, [this.state.ServiceType, 'timeWindowOptions'], [])        
        }
    }

   addRecord() {
       this.setState({
           showModal: true,
           currentRecord: {
           },
       })
   }
    editRecord(row) {
        const showAdministratorModeCheckbox = row.Type === 'Dropoff' || row.Type === 'Mail In'
        this.setState({
            administratorMode: ! showAdministratorModeCheckbox,
            showAdministratorModeCheckBox: showAdministratorModeCheckbox
        })

        fetchServiceSettings.call(this, {MarketName: row.MarketName}).then(() => {
            fetchDateRules.call(this, {Name: row.MarketName + 'ServiceDateRules'}).then(() => {
                this.moment.tz.setDefault(_.get(_.find(config.warehouseData, {MarketName: row.MarketName}), 'timeZoneName'));
                getScheduledServices.call(this, {MarketName: row.MarketName})

                var foundTimeWindow = _.find(this.orderData[row.Type].timeWindowOptions, {value: row.TimeWindow})
                this.filteredServiceAreasForLocation = row.ServiceAreaRecord ? [row.ServiceAreaRecord] : []
                console.log('row.ServiceAreaRecord', row, row.ServiceAreaRecord);
                if (!row.ServiceAreaRecord && row.Type == 'Pickup') {
                    this.props.displayMessage({
                        'messageType': 'warning',
                        'messageCode': 'Service area is not found'
                    });
                }
                this.setState({
                    showModal: true,
                     ServiceType: row.Type,
                    serviceAreasForLocation: row.ServiceAreaRecord ? [row.ServiceAreaRecord] : [],
                    PickupDate: this.moment(row.ServiceStartTime),
                    Size: row.Size,
                    CurrentLocation:row.MarketName,
                    Status: row.Status,
                    errors: {},
                    sellersProductsUploaded: false,
                    sellersProductsActive: false,
                    sellerHasDonationItems: '',
                   // userEmailsToCrossPost: [],
                    TimeWindow: foundTimeWindow ? foundTimeWindow : false,
                    currentRecord: {
                        ...row,
                    },

                }, function () {
                    updateSelectedServiceData.call(this, {user: 'administrator'})
                    /* update data when opening modal*/
                });
            })
        })
    }


    closeModal() {
        console.log('on close modal');
        this.setState({
            showModal: false,
            currentRecord: {},
        });
    }

    closeDetailsModal() {
        this.setState({
            showDetailsModal: false,
            currentRecord: {},
        });
    }

    showRemoveDialog(row) {
        this.setState({removeRecordModalVisible: true, currentRecord: row});
    }

    cancelRecord() {
        this.setState({removeRecordModalVisible: false});
        var self = this;
        var methodData = {
            "endpoint": "/pickups" + '/' + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
            messageCode: 'Service is cancelled',
        };
        self.props.makeRequest({Status: 'Cancelled'}, methodData).then(pickupUpdateResponse => {
            this.setState({currentRecord: {}});
            self.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
        });

    }

    deleteService() {
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'delete',
            "endpoint": "/pickups",
            messageData: {'#1#': 'Service'},
            messageCode: 'recordDeleted',
        };
        this.props.makeRequest({id: this.state.currentRecord._id}, methodData).then(res => {
            this.setState({currentRecord: {}});
            this.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
            console.log('e', err);
        });

    }

    validateAndGetPickupFormData() {
        var formData = _.pick(this.state, ['PickupDate', 'Status'])
        if (!this.state.TimeWindow) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    TimeWindow: true
                }
            }, () => this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFieldNotSpecified',
                messageData: {'#1#': 'Pickup time'}
            }));
            return false
        }
        if (this.state.PickupDate == '') {
            this.setState({
                errors: {
                    ...this.state.errors,
                    PickupDate: true
                }
            });
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFieldNotSpecified',
                messageData: {'#1#': 'Pickup date'}
            });
            return false;
        }

        if (!this.moment(this.state.PickupDate, 'D/M/YYYY').isValid()) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    PickupDate: true
                }
            });
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorDateIsNotValid',
            });
            return false;
        }

        if (!checkValidDates.call(this, {user: 'administrator', current: momentTimeZone(this.state.PickupDate)})) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    PickupDate: true
                }
            });
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorDateIsNotAvailable',
            });
            return false;
        }
        formData.TimeWindow = this.state.TimeWindow.value

        if (this.state.Size == false) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    Size: true
                }
            }, () => this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFieldNotSpecified',
                messageData: {'#1#': (this.state.ServiceType == 'Pickup' ? 'Pick-up' : 'Drop-off') + ' size'}
            }));
            return false;
        }
        formData.Size = this.state.Size


        return formData
    }

    updateServiceStatus(params = {}) {
        var self = this;
        this.setState({pending: true});
        var formData = _.pick(this.state, ['Status'])
        if (formData.Status == 'Out For Approval' && this.state.currentRecord.Status !== 'Out For Approval') {
            if (!_.includes(['yes', 'no'], _.get(this.state.sellerHasDonationItems, 'value'))) {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        pending: false,
                        sellerHasDonationItems: true
                    }
                }, () => this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, specify if the seller has any donations items',

                }));
                return false;
            }
            formData.sellerHasDonationItems = _.get(this.state.sellerHasDonationItems, 'value')
            formData.sellersProductsActive = this.state.sellersProductsActive
            formData.sellersProductsUploaded = this.state.sellersProductsUploaded

        }
        // else if (((formData.Status == 'Complete' && this.state.currentRecord.Status !== 'Complete') || (formData.Status == 'Hold Donations For Pickup' && this.state.currentRecord.Status !== 'Hold Donations For Pickup'))) {
        //     if (_.size(this.state, 'userEmailsToCrossPost', [])) {
        //         formData.userEmailsToCrossPost = _.map(this.state.userEmailsToCrossPost, item => {
        //             return {'name': item.firstName + (item.lastName ? ' ' + item.lastName : ''), 'address': item.email}
        //         })
        //     }
        //  }
        _.extend(formData, params)
        var methodData = {
            "endpoint": "/pickups" + '/' + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
        };
        self.props.makeRequest(formData, methodData).then(response => {
            self.setState({pending: false,
              // userEmailsToCrossPost: []
            });
            self.search()
            self.closeDetailsModal()
        }).catch(err => {
            self.setState({pending: false});
        });
    }

    saveRecord() {
        var self = this;
        this.setState({pending: true});
        var formData = this.validateAndGetPickupFormData();
        if (!formData) {
            this.setState({pending: false});
            return false;
        }
        if (this.state.administratorMode) {
            formData.administratorMode = true;
        }
        var methodData = {
            "endpoint": "/pickups" + '/' + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
        };
        self.props.makeRequest(formData, methodData).then(pickupUpdateResponse => {
            self.setState({pending: false});

            self.search({page:self.state.currentPage+1})
            self.closeModal()
        }).catch(err => {
            self.setState({pending: false});
        });
    }

    getUsersByRoles() {
        var self = this;
        this.props.makeRequest({
            all: true,
            Roles: ["Wingmom"],
        }, {
            'endpoint': '/users',
            'not_display_success_message': true,
        }).then(res => {

            var WingmomUsers = _.get(res.data, 'data', [])
            if (config.getEnvironmentName() == 'development') {
                WingmomUsers.push({email: 'kihra@goodbuygear.com', _id: '111', firstName: 'Kihra'})
            }
            self.setState({WingmomUsers: WingmomUsers})
        })
    }

    onSortChange(field, sortOrder) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
        if (_.get(this.state.currentRecord, '_id') == 'new_record'){
            return;
        }
        if (this.searchBox) {
            var {queryParams} = this.searchBox.getSearchParams();
        } else {
            var queryParams = {}
        }

        _.extend(queryParams, params);
      //  if (_.isUndefined(params.include)){/* do not use addFields when Select all is pressed*/
          // queryParams.addFields = ['ProductsTotalNumber',
          //     'PrelistingsTotalNumber', 'FeesTotalNumber'
          // ]
          //   queryParams.ServiceProductsFieldsToInclude =  {
          //               _id: 1,
          //           ShopifyProductID: 1,
          //       ProductVariations:1
          //   }
     //   }
        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'PickupNumber' + ':' + (-1);
        }

        queryParams.sortBySecondary = '_id:-1';
        /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
        var methodData = {
            "endpoint": "/pickups",
            'not_display_success_message': true,
        };
        if (_.isUndefined(params.page)) { /* do not clear selected records when only pagination is changed */
            this.props.dispatchAction({}, CLEAR_SELECTED_SERVICES)
        }
        if (queryParams.page == 1) {
            queryParams.page = undefined;
        }
        if (_.isUndefined(params.include)) {
            methodData['success_event'] = FETCH_ADMIN_SERVICES;
        }
        if (queryParams.all  && !_.isUndefined(params.page) && this.props.adminServices.data.length > 20) {
            console.log('dataToDisplay pagination', this.props.adminServices.data.length);
            var from = (queryParams.page - 1) * queryParams.perPage
            var to = from + parseInt(queryParams.perPage)
            this.setState({dataToDisplay: this.props.adminServices.data.slice(from, to), pending:false})
            return;
        }

        if (_.isUndefined(params.doNotUpdateUrlString)) {
            var fieldsToOmit = ['include', 'lookup', 'all', 'sortBySecondary']
            if (queryParams.perPage ==10){
                fieldsToOmit.push('perPage')
            }
            if (queryParams.sortBy == 'PickupNumber' + ':' + (-1)){
                fieldsToOmit.push('sortBy')
            }
            const stringified = queryString.stringify(_.omit(queryParams, fieldsToOmit));
            this.context.router.push('/admin/services?' + stringified);
        }
        queryParams.lookup = ['Sellers', 'ServiceArea'  ]

        return this.props.makeRequest(queryParams, methodData).then(res => {
            this.setState({pending:false})
            var dataToDisplay = []
            if (_.isUndefined(params.include)) {
                if ( queryParams.all && res.data.total > 20) {
                    dataToDisplay = res.data.data.slice(0, queryParams.perPage)
                }
            }
            this.setState({dataToDisplay: dataToDisplay})
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                this.refs.pagination.resetPagination();
            }
            return res
        }).catch(err => {
            this.setState({pending:false})
            return err
        });
    }

    onDateChange(option) {
        var d = momentTimeZone(option, 'D/M/YYYY');
        console.log('on date change', option);
        if (d == null || !d.isValid()) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    PickupDate: true
                }, PickupDate: false,
            }, function () {

            });
            return false;
        }
        this.setState({
            'PickupDate': option, errors: {
                ...this.state.errors,
                PickupDate: false
            }
        }, function () {
            updateSelectedServiceData.call(this, {user: 'administrator'})
        });
    }

    displayDetailsModalContent() {
        // var usersDataToDisplay = _.chunk(this.state.WingmomUsers, 2)
        //         { _.map(chunk, (userData, index) => {
        //             return <span  style={index % 2 == 0 ? {
        //                 overflow:'hidden',  alignSelf: 'flex-start', width:'45%',marginRight:15,
        //                 display: 'flex'
        //             } : {   overflow:'hidden', alignSelf: 'flex-end',  display: 'flex',width:'45%',}}><Checkbox
        if (this.state.Status == 'Out For Approval') {
            return <FormGroup>
                <ControlLabel>Processing checklist</ControlLabel>
                <div className="top5">
                    <Checkbox onChange={(e) => {
                        this.setState({sellersProductsUploaded: !this.state.sellersProductsUploaded})
                    }}
                              checked={this.state.sellersProductsUploaded} inline><span className="left5">Seller's products uploaded</span></Checkbox>
                </div>
                <div className="top10 bot10">
                    <Checkbox onChange={(e) => {
                        this.setState({sellersProductsActive: !this.state.sellersProductsActive})
                    }}
                              checked={this.state.sellersProductsActive} inline><span className="left5">Seller's products Active with "Pre-order" tag</span></Checkbox>
                </div>

                <ControlLabel className="top25">Does the seller have any donation items?</ControlLabel>
                <Select
                    options={  [{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]}
                    onChange={ (option) => {
                        this.setState({'sellerHasDonationItems': option ? option : false});
                    }}
                    onFocus={(e) => this.setState({
                        errors: {
                            ...this.state.errors,
                            sellerHasDonationItems: false
                        }
                    }) }
                    style={this.state.errors['sellerHasDonationItems'] ? {border: '1px solid red'} : {} }
                    value={this.state.sellerHasDonationItems}
                />
            </FormGroup>
        }
        // else if (this.state.Status == 'Complete' || this.state.Status == 'Hold Donations For Pickup') {
        //     return <FormGroup>
        //
        //         <div className="">
        //             <ControlLabel>Select Wingmoms to Cross-Post</ControlLabel>
        //             {_.map(this.state.WingmomUsers, (userData, index) => {
        //                 var checked = _.findIndex(this.state.userEmailsToCrossPost, {_id: userData._id}) == -1 ? false : true
        //                 return <div key={index}><Checkbox
        //                     onChange={(e) => {
        //                         if (e.target.checked) {
        //                             this.setState({userEmailsToCrossPost: _.concat(this.state.userEmailsToCrossPost, [userData])})
        //                         } else {
        //                             var itemIndex = _.findIndex(this.state.userEmailsToCrossPost, {_id: userData._id})
        //                             this.setState({
        //                                 userEmailsToCrossPost: [...this.state.userEmailsToCrossPost.slice(0, itemIndex),
        //                                     ...this.state.userEmailsToCrossPost.slice(itemIndex + 1)]
        //                             })
        //                         }
        //                     }}
        //                     checked={checked} inline><span
        //                     className="left5">{userData.email}</span></Checkbox></div>
        //             })}
        //
        //         </div>
        //
        //
        //     </FormGroup>
        // }
    }

    render() {
        console.log('AdminServicesPage this state', this.state);
        return (
            <div >
                {config.checkAccessRights.call(this,{ resources:['services_full']}) &&
                <AdminServicesActionsBox orderData={this.orderData}
                                         {...this.props} ></AdminServicesActionsBox>
                }
                <AdminServiceSearchBox pending={this.state.pending}
                                       ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox;
                            if (_.size(_.get(this.props.location.query, 'recordIDs', []))  ) { /* by default search only if recordIDs are passed*/
                                this.search({page:this.state.currentPage+1})
                            }

                        }
                    } }
                    selectAllRecords={this.state.selectAllRecords}
                    addRecord={this.addRecord.bind(this)}
                    toggleAllRecordsSelection={ (value) => {
                        console.log('value', value);
                        if (value) {
                            this.setState({selectAllRecords: true});
                        } else {
                            this.setState({selectAllRecords: false});
                        }
                    }  }
                    search={this.search.bind(this)}
                    {...this.props} ></AdminServiceSearchBox>
                {this.props.adminServices.fetched &&
                <div>
                    {this.props.adminServices.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'services')}</div> :
                        <div className="top20">

                            <AdminServiceListTable
                                onSortChange={this.onSortChange.bind(this)}
                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                editRecord={this.editRecord.bind(this)}
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                total={this.props.adminServices.total == 'initial' ? 0 : this.props.adminServices.total}
                                data={this.state.dataToDisplay.length > 0 ? this.state.dataToDisplay :this.props.adminServices.data}

                                search={this.search.bind(this)} {...this.props}  ></AdminServiceListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={(this.props.adminServices.total ==_.size(this.props.adminServices.data) && _.size(this.state.dataToDisplay) ==0)?
                                    undefined:
                                    (this.searchBox ? this.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined))}
                                ref={'pagination'}
                                total={this.props.adminServices.total == 'initial' ? 0 : this.props.adminServices.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }
                <Modal onExited={this.closeDetailsModal.bind(this)} show={this.state.showDetailsModal}
                       onHide={(e) => this.closeDetailsModal()}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.Status }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.displayDetailsModalContent()}
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">

                                <Button className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={() => {
                                            this.updateServiceStatus({})
                                        }}>

                                    {this.state.Status == 'Out For Approval' ? 'Send approval email and sms' : 'Posting Complete'}
                                </Button>
                                <Button className=" right0 pull-right right20 btn btn-primary " type="button"
                                        onClick={() => {
                                            this.updateServiceStatus({userEmailsToCrossPost: [], doNotSendEmailOrSMS: true})
                                        }}>
                                    {'Save without sending email and sms'}
                                </Button>

                            </Col>
                            <Col md={12} sm={12} xs={12} className="top10 pleft0">
                                <Button className="pull-left btn right0 btn-default" type="button"
                                        onClick={(e) => {
                                            this.closeDetailsModal()
                                        } }>
                                    Cancel
                                </Button>


                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

                <Modal onExited={() => {
                    if (!this.state.showDetailsModal) {
                        this.closeModal()
                    }
                }} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{_.get(this.state.currentRecord, '_id') == 'new_record' ? 'Add new': 'Edit'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form  >
                            {_.get(this.state.currentRecord, '_id') == 'new_record' &&
                            <FormGroup>
                                <ControlLabel>Type</ControlLabel>
                                <Select
                                    options={ config.services.serviceTypesMap}
                                    onChange={ (option) => {
                                        this.setState({
                                            'Type': option ? option.value : false
                                        }, function () {
                                            updateSelectedServiceData.call(this, {user: 'administrator'})
                                        })
                                    }}

                                    placeholder="Type"
                                    value={this.state.Type}

                                 />
                            </FormGroup>
                            }
                            <FormGroup>
                                <ControlLabel>Date</ControlLabel>
                                <Datetime
                                    isValidDate={(date) => checkValidDates.call(this, {
                                        user: 'administrator',
                                        filterServiceAreas: false,
                                        current: date
                                    }) }
                                    closeOnSelect={true}
                                    dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                    onChange={(value) => this.onDateChange.call(this, value)}
                                    inputProps={{
                                        placeholder: ''

                                    }}
                                    value={this.state.PickupDate}
                                    className={this.state.errors['PickupDate'] ? "red-border-date-picker " : ""}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Time</ControlLabel>
                                <Select
                                    options={ this.getTimeOptions() }
                                    onChange={ (option) => {
                                        this.setState({'TimeWindow': option ? option : false}, function () {
                                            updateSelectedServiceData.call(this, {user: 'administrator'})
                                        });
                                    }}
                                    value={this.state.TimeWindow}
                                    onFocus={(e) => this.setState({
                                        errors: {
                                            ...this.state.errors,
                                            TimeWindow: false
                                        }
                                    }) }
                                    style={this.state.errors['TimeWindow'] ? {border: '1px solid red'} : {} }
                                />
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Size</ControlLabel>
                                <Select
                                    options={_.get(config.services, [this.state.ServiceType.toLowerCase(), 'sizeOptions'], [])  }
                                    onChange={ (option) => {
                                        this.setState({
                                            'Size': option ? option.value : false, errors: {
                                                ...this.state.errors,
                                                Size: false
                                            }
                                        }, function () {
                                            updateSelectedServiceData.call(this, {user: 'administrator'})
                                        })
                                    }}

                                    placeholder="Size"
                                    value={this.state.Size}
                                    onFocus={(e) => this.setState({
                                        errors: {
                                            ...this.state.errors,
                                            Size: false
                                        }
                                    }) }
                                    style={this.state.errors['Size'] ? {border: '1px solid red'} : {} }
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Status</ControlLabel>

                                <Select
                                    options={_.reject(_.map(config.serviceStatusList, item => {
                                        return {value: item, label: item}
                                    }),{Status:'Active'})  }
                                    onChange={ (option) => {
                                        this.setState({
                                            'Status': option ? option.value : false,
                                        }, function () {
                                            if (((_.get(option, 'value') == 'Complete' && this.state.currentRecord.Status !== 'Complete') || (_.get(option, 'value') == 'Hold Donations For Pickup' && this.state.currentRecord.Status !== 'Hold Donations For Pickup')) && _.size(this.state.WingmomUsers) == 0) {
                                                this.getUsersByRoles()
                                            }
                                             if (   _.get(option, 'value') == 'Out For Approval' && this.state.currentRecord.Status !== 'Out For Approval') {
                                                this.setState({
                                                    'showModal': false,
                                                    showDetailsModal: true,
                                                })
                                            }
                                        })
                                    }}

                                    placeholder="Status"
                                    value={this.state.Status}

                                />
                            </FormGroup>
                            {this.state.showAdministratorModeCheckBox &&
                                <FormGroup>
                                    <Checkbox onChange={(e) => {
                                            this.setState({administratorMode: !this.state.administratorMode}, () => {
                                                updateSelectedServiceData.call(this, {user: 'administrator'})
                                            })
                                        }}
                                        checked={this.state.administratorMode} inline><span className="left5">Administrator mode</span>
                                    </Checkbox>
                                </FormGroup>
                            }
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                        <Button
                                        disabled={this.state.pending}
                                        className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={()=>{
                                        if (!this.state.pending) {
                                        this.saveRecord()
                                    }} }>
                                        Save
                                        </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => {
                        if (_.get(this.state.currentRecord, 'actionToProcess') == 'cancel') {
                            this.cancelRecord()
                        } else {
                            this.deleteService()
                        }
                    } }
                    modalTitleText={_.get(this.state.currentRecord, 'actionToProcess') == 'cancel' ? 'Are you sure you want to cancel this service?' : ''}
                    confirmButtonText={_.get(this.state.currentRecord, 'actionToProcess') == 'cancel' ? 'Cancel service' : ''}
                    cancelButtonText={_.get(this.state.currentRecord, 'actionToProcess') == 'cancel' ? 'Close' : ''}

                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        adminServices: state.adminServices,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminServicesPage);
